var uuid = function () {

  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );

}

class Customizer extends HTMLElement {

  constructor() {

    super();

  }

  connectedCallback() {
    
    this.addEventListener('customizer:customization:update-embroidery-type', this.onEmbroideryTypeUpdate.bind(this));
    this.addEventListener('customizer:customization:update-design-type', this.onDesignTypeUpdate.bind(this));
    this.addEventListener('customizer:customization:update', this.onCustomizationUpdate.bind(this));
    
    this.addEventListener('customizer:placement:select', this.onPlacementSelect.bind(this));
    this.addEventListener('customizer:placement:deselect', this.onPlacementDeselect.bind(this));
    
    this.addEventListener('product-info:variant:change', this.onVariantChanged.bind(this));
    this.addEventListener('product-info:variant:updated', this.onVariantUpdated.bind(this));

    this.addEventListener('customizer:state:store', this.onStoreState.bind(this));
    this.addEventListener('customizer:placement:select', this.onStoreState.bind(this));
    this.addEventListener('product-info:variant:updated', this.onStoreState.bind(this));
    this.addEventListener('customizer:customization:update', this.onStoreState.bind(this));

    document.querySelectorAll(`#MainContent [name="quantity"]`).forEach(e => {
      e.addEventListener('change', this.onQuantityChange.bind(this));
    });
    
    document.querySelectorAll(`.swatches input[type="radio"]`).forEach(e => {
      e.addEventListener('change', this.onSwatchChange.bind(this));
    });

    // this.formSubmitButton.addEventListener("click", this.onSubmitForm.bind(this));
    this.form.addEventListener("submit", this.onSubmitForm.bind(this));
    
    this.querySelectorAll('[data-start-over]').forEach(e => {
      e.addEventListener('click', this.startOver.bind(this));
    });

    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantUpdated.bind(this));

    this.reset();

  }

  reset() {
    
    this.placements.reset()
    this.checkForProductState();
    this.validateForm();

  }

  scrollToTop() {
    this.anchor.scrollIntoView();
  }

  startOver() {
   
    this.reset();
    this.scrollToTop();

  }

  validateForm() {

    // console.log('validateForm');

    const formMessages = this.querySelector(`customizer-form-messages`);
    
    let section = this.querySelector(`[id="step-2"]`);

    if (this.validateOrder() == true) {
      this.enableAddToCart();
      formMessages.classList.add(`hidden`);
    }
    else {
      // console.log('validateForm - disable');
      this.disableAddToCart();
      formMessages.classList.remove(`hidden`);
    }

  }

  validateOrder() {

    // console.log('validateOrder');

    if (this.activeCustomizations.length > 0) {
      // console.log(true);
      return true;
    }
    else {
      // console.log(false);
      return false;
    }

  }

  updateOrder() {

    this.customizerOrder.update();

  }

  /* ----- State Recall ----- */

  showStatePopup() {

    // alert("It looks like you've been here before! We still remember your customizations - would you like to pick up where you left off?");

  }

  recallStateByProductId(productId) {

    const productStorageId = `CustomizerState-${productId}`;

    return JSON.parse(localStorage.getItem(productStorageId));

  }

  storeCurrentProductState() {

    const state = this.getStateFromUI();
    // console.log(state);

    this.storeProductState(state);

  }

 storeProductState(state) {

  if (!state) {
    return;
  }

  if (typeof state != "object") {
    return;
  }

  if (!this.validateProductState(state)) {
    return;
  }

  const dataString = JSON.stringify(state);
  const productStorageId = `CustomizerState-${state.productId}`;
  
  localStorage.setItem(productStorageId, dataString);

 }

  validateProductState(state) {

    if (!state) {
      return;
    }

    if (!state.productId) {
      // console.log('%c[Customizer] No Product ID...', "color: red");
      return false
    }

    if (!state.variantId) {
      // console.log('%c[Customizer] No Variant ID...', "color: red");
      return false
    }

    if (!state.customizations) {
      // console.log('%c[Customizer] No Customizations...', "color: red");
      return false
    }

    return true;

  }

  checkForProductState() {
  
    const productState = this.recallStateByProductId(this.productJson.id);

    if (productState && this.validateProductState(productState)) {
      
      /*
      // Show Prompt
      const confirm = window.confirm("It looks like you've been here before! We still remember your customizations - would you like to pick up where you left off?");

      if (confirm == true) {
        this.populateState(productState);
      }
      */

      this.populateState(productState);

    }
    else {
      // console.log('%c[Customizer] No Stored State for Product.', "color: red");
      return false;
    }
    
  }

  populateState(state) {

    const productId = state.productId;
    const variantId = state.variantId;
    const customizations = state.customizations;

    // Select Variant


    // For Each Customization
    for (let c = 0; c < customizations.length; c++) {
      
      const customizationState = customizations[c];
      
      const positionName = customizationState.position;
      const positionContainer = this.querySelector('customizer-placements-container');
      const position = positionContainer.querySelector(`[data-placement-name="${ positionName }"]`);

      const customization = this.querySelector(`customization-details[data-name="${ positionName }"]`);

      // Select Placement
      this.showCustomization(position);

      // Populate Customization Settings
      customization.populate(customizationState);

    }
    
    

  }


  getStateFromUI() {

    // Get the state of the current product from the UI.

    const productState = {};

    productState.productId = this.productJson.id;
    productState.variantId = this.selectedVariantData.id;
    // productState.customizations = this.activeCustomizations;

    productState.customizations = []; 
    
    this.activeCustomizations.forEach(e => {

      const customizationState = {};

      customizationState.position = e.getAttribute("data-name");
      customizationState.embroideryType = e.embroideryType;
      customizationState.designType = e.designType;

      if (customizationState.designType == "Image") {
        customizationState.file = e.querySelector("[data-input-file]").value;
      }
      else 
      if (customizationState.designType == "Text") {
        customizationState.text = e.querySelector("[data-input-text]").value;
      }

      productState.customizations.push(customizationState);

    });

    return productState;

  }

  onStoreState() {

    this.storeCurrentProductState();

  }

  /* ----- Customizer ----- */

  getVariantData(variantId) {

    const productData = this.productJson;
    const selectedVariantId = this.selectedVariantId;
    
    let selectedVariant;

    for (let v = 0; v < productData.variants.length; v++) {
      const variant = productData.variants[v];

      if (variant.id == selectedVariantId) {
        selectedVariant = variant;
        break;
      }

    }

    if (!selectedVariant) {
      return false;
    }
    else {
      return selectedVariant;
    }

  }

  onClickAddButton(event) {
    // console.log('onClickAddButton');
    this.form.submit();
  }

  async onSubmitForm(event) {

    event.preventDefault();

    let customizationsValid = [];
    let customizationsInvalid = [];

    for (let c = 0; c < this.activeCustomizations.length; c++) {
      const customization = this.activeCustomizations[c];
      customization.validateInputs();
      if (customization.valid == false) {
        customizationsInvalid.push(customization);
      }
      else {
        customizationsValid.push(customization);
      }
    }

    if (customizationsInvalid.length > 0) {
      customizationsInvalid[0].form.requestSubmit();
      return;
    }

    this.cart = document.querySelector('cart-notification') || document.querySelector('drawer-component');

    // Animate Button
    this.formSubmitButton.setAttribute('aria-disabled', true);
    this.formSubmitButton.classList.add('loading');
    this.formSubmitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    // Populate Form
    this.formClear();
    this.formPopulate();

    // Send Payload

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    // const updateResponse = await fetch(`${routes.cart_add_url}`, config);

    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {

      if (response.status) {
        
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });

        // Handle Errors
        // this.handleErrorMessage(response.description);

        // Handle Sold Out
        /*
        const soldOutMessage = this.formSubmitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.formSubmitButton.setAttribute('aria-disabled', true);
        this.formSubmitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
        */

      }

      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
      
      this.error = false;

      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              this.cart.renderContents(response);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        
        this.cart.renderContents(response); // <--- THIS CAUSES THE ISSUE
        this.cart.open();

      }

      return false;
      
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {

      // Remove Button Animation
      this.formSubmitButton.setAttribute('aria-disabled', false);
      this.formSubmitButton.classList.remove('loading');
      this.formSubmitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');

    });

    return false;

  }

  formClear() {
    this.form.innerHTML = "";
  }

  formPopulate() {

    // console.log('formPopulate');

    let formHTML = ``;

    // Prepare Values
    const productVariantId = this.selectedVariantId;
    const quantity = parseInt(this.quantitySelector.value);
    const addonToken = "ADDON_" + uuid();
    const instructions = this.specialInstructionsInput.value;
    const selectedVariantData = this.getVariantData();
    const selectedVariantName = selectedVariantData['name'];
    const parentFieldName = 'Parent';

    // console.log(selectedVariantData);

    formHTML += `
    <input class="input" type="text" name="items[${parentFieldName}]id" value="${productVariantId}">
    <input class="input" type="number" name="items[${parentFieldName}]quantity" value="${quantity}">
    <input class="input" type="text" name="items[${parentFieldName}]properties[_addonID]" value="${addonToken}">
    `;
 
    if (instructions) {
      formHTML += `<input class="input" type="text" name="items[${parentFieldName}]properties[Special Instructions]" value="${instructions}">`;
    }

    for (let c = 0; c < this.activeCustomizations.length; c++) {
      const customization = this.activeCustomizations[c];
      const customizationIndex = (c + 1);
      const customizationName = customization.name;
      const customizationHandle = customization.handle;
      const customizationProduct = customization.selectedProductData;
      const customizationVariantId = customizationProduct.variants[0].id;
      const customizationVariantName = customizationProduct.variants[0].id;
      const customizationFieldset = customization.fieldset;

      formHTML += `
      <input class="input" type="text" name="items[${ customizationName }]id" value="${ customizationVariantId }">
      <input class="input" type="text" name="items[${ customizationName }]properties[_addon]" value="true">
      <input class="input" type="text" name="items[${ customizationName }]properties[_addonID]" value="${ addonToken }">
      <input class="input" type="text" name="items[${ customizationName }]properties[_Customization For:]" value="${ selectedVariantName }">
      <input class="input" type="text" name="items[${ customizationName }]properties[Position]" value="${customization.dataset.name }">
      <input class="input" type="number" name="items[${ customizationName }]quantity" value="${quantity}">
      `;

      if (customizationFieldset) {
        const inputs = customizationFieldset.querySelectorAll("input");
        for (let f = 0; f < inputs.length; f++) {
          const input = inputs[f];

          if (input.type == "file") {

          }
          else {

            let newInput = input.cloneNode(true);
            newInput.className = "";
            newInput.name = `items[${customizationName }]properties[${newInput.dataset.fieldName}]`;
  
            this.form.insertAdjacentElement('beforeend', newInput);

          }
        }
      }

    }

    this.form.insertAdjacentHTML('beforeend', formHTML);


  }

  onVariantChanged(event) {

  }

  onVariantUpdated(event) {

    this.updateOrder();

  }

  onQuantityChange(event) {

    const input = event.currentTarget;
    const inputValue = input.value;
    const inputName = input.getAttribute("name");
    const inputs = document.querySelectorAll(`#MainContent input[name="${inputName}"]`);

    for (let i = 0; i < inputs.length; i++) {
      const thisInput = inputs[i];

      if (thisInput == input) {
        continue;
      }

      thisInput.value = parseInt(inputValue);

    }

  }

  onSwatchChange(event) {

    const input = event.currentTarget;
    const inputValue = input.value;
    const inputName = input.getAttribute("name");

    const inputs = document.querySelectorAll(`.swatches input[value="${inputValue}"]`);

    for (let i = 0; i < inputs.length; i++) {
      const thisInput = inputs[i];
      
      if (thisInput == input) {
        continue;
      }

      if (thisInput.value == inputValue) {
 
        thisInput.checked = true;

        const variantRadios = thisInput.closest("variant-radios");

        // console.log(variantRadios);

        variantRadios.updateOptions();
        variantRadios.updateMasterId();
        variantRadios.toggleAddButton(true, '', false);
        variantRadios.updatePickupAvailability();
        variantRadios.removeErrorMessage();
        variantRadios.updateVariantStatuses();

        if (!variantRadios.currentVariant) {

          variantRadios.toggleAddButton(true, '', true);
          variantRadios.setUnavailable();

        } else {

          variantRadios.updateMedia();
          variantRadios.updateURL();
          variantRadios.updateVariantInput();
          variantRadios.renderProductInfo();
          variantRadios.updateShareUrl();

        }

      }

    }

  }

  onEmbroideryTypeUpdate(event) {
    this.customizerOrder.updatePrices(this.selectedVariantData);
  }
  
  onDesignTypeUpdate(event) {
  }
  
  onCustomizationUpdate(event) {
    
    this.customizerOrder.updateCustomizations();

  }

  onPlacementSelect(event) {

    const placement = event.detail.placement;
    this.showCustomization(placement);

    this.validateForm();

  }

  showCustomization(placement) {

    const handle = placement.dataset.placementHandle;
    const customization = document.querySelector(`customization-details[data-handle="${handle}"]`);
    const customizationSummary = document.querySelector(`customization-summary[data-handle="${handle}"]`);

    placement.selected = true;

    customization.show();
    customizationSummary.show();
    customizationSummary.update(customization);

    this.customizerOrder.updateCustomizations();
    this.customizerOrder.updatePrices(this.selectedVariantData);

  }

  onPlacementDeselect(event) {

    const placement = event.detail.placement;
    const handle = event.detail.placement.dataset.placementHandle;
    const customization = document.querySelector(`customization-details[data-handle="${handle}"]`);
    const customizationSummary = document.querySelector(`customization-summary[data-handle="${handle}"]`);

    customization.reset();
    customizationSummary.hide();

    this.customizerOrder.updateCustomizations();
    this.customizerOrder.updatePrices(this.selectedVariantData);

    this.validateForm();

  }

  enableAddToCart() {
    this.formSubmitButton.disabled = false;
    this.formSubmitButton.setAttribute('aria-disabled', false);
  }

  disableAddToCart() {
    this.formSubmitButton.disabled = true;
    this.formSubmitButton.setAttribute('aria-disabled', true);
  }

  get selectedVariantData() {
    return this.getVariantData(this.selectedVariantId);
  }

  get anchor() {
    return this.querySelector('[data-customizer-anchor]');
  }

  get productJson() {
    return JSON.parse(this.dataset.productJson);
  }

  get selectedVariantId() {
    return parseInt(this.querySelector(".product-variant-id").value);
  }

  get customizerOrder() {
    return this.querySelector("customizer-order");
  }

  get placements() {
    return this.querySelector("customizer-placements-container");
  }

  get form() {
    return this.querySelector("[data-customizer-form]");
  }
  
  get quantitySelector() {
    return this.querySelector("customizer-quantity-input");
  }

  get formSubmitButton() {
    return this.querySelector("[data-add-to-cart-button]");
  }

  get selectVariantForm(){
    return this.querySelector('[data-type="add-to-cart-form"]');
  }
  
  get selectedProductId(){
    return parseInt(this.selectVariantForm.querySelector('[name="product-id"]').value);
  }
  
  get selectedVariantId(){
    return parseInt(this.selectVariantForm.querySelector('[name="id"]').value);
  }

  get specialInstructionsInput() {
    return this.querySelector('[name="special-instructions"]');
  }

  get activeCustomizations() {

    const array = Array.from(this.querySelectorAll('customization-details'));
    const arrayFiltered = array.filter(e => e.classList.contains("customization--visible"));

    return arrayFiltered;

  }

}

class CustomizerQuantityInput extends HTMLElement {
  constructor() {

    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    
    event.preventDefault();
    const previousValue = this.input.value;

    switch (event.target.name) {
      case 'plus_10':
        this.input.value = parseInt(this.input.value) + 10;
        break;
      case 'minus_10':
        this.input.value = parseInt(this.input.value) - 10;
        break;
      case 'plus':
        this.input.stepUp();
        break;
      case 'minus':
        this.input.stepDown();
        break;

    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

  }

  validateQtyRules() {

    const value = parseInt(this.input.value);
    
    if (this.input.min) {

      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector("button[name='minus']");
      const buttonMinus10 = this.querySelector("button[name='minus_10']");

      buttonMinus.disabled = value <= min;
      buttonMinus10.disabled = value < 10;

    }

    if (this.input.max) {
      
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector("button[name='plus']");
      const buttonPlus10 = this.querySelector("button[name='plus_10']");
      
      buttonPlus.disabled = value >= max;
      buttonPlus10.disabled = value >= 10;

    }

    if (parseInt(this.input.value) > parseInt(this.input.max)) {
      this.input.value = parseInt(this.input.max);
    }

    if (parseInt(this.input.value) < parseInt(this.input.min)) {
      this.input.value = parseInt(this.input.min);
    }

    if (!this.input.value) {
      this.input.value = 1;
      buttonMinus.disabled = true;
      buttonMinus10.disabled = true;
    }

  }

  get value() {
    return this.input.value;
  }

}

class CustomizationMessages extends HTMLElement {

  constructor() {

    super();

  }

  connectedCallback() {

  }

  get hidden() {
    return this.dataset.group;
  }

  show() {
    this.classList.add("customizer-placement--disabled");
  }

  hide() {
    this.classList.remove("customizer-placement--disabled");
  }

}

class Customization extends HTMLElement {

  constructor() {

    super();

    this.reset();

  }

  connectedCallback() {

    const this2 = this;

    this.querySelectorAll('[data-swatch-embroidery-type]').forEach(e => {
      e.addEventListener("change", this2.onChangeEmbroideryType.bind(this));
    });

    this.querySelectorAll('[data-swatch-design-type]').forEach(e => {
      e.addEventListener("change", this2.onChangeDesignType.bind(this));
    });

    this.querySelector('[data-input-file]').addEventListener("change", this.onChangeFile.bind(this));
    this.querySelector('[data-input-text]').addEventListener("keyup", this.onChangeInput.bind(this));

    this.update();
    this.updateDesignType();

  }

  onChangeInput(e) {

    const input = e.target;
    this.update();

  }

  onChangeFile(e) {

    const input = e.target;
    this.update();

  }

  onChangeEmbroideryType(e) {

    const swatch = e.target;
    const productData = JSON.parse(swatch.dataset.product);
    const price = productData.price;

    this.updatePrice(price);

    this.update();

    const event = new CustomEvent('customizer:customization:update-embroidery-type', {
      'bubbles': true,
      'detail': {
        "customization": this
      }
    });

    this.dispatchEvent(event);

  }

  get selectedEmbroideryProduct() {
    return JSON.parse(this.querySelector("[data-swatch-embroidery-type]:checked").dataset.product);
  }

  onChangeDesignType(e) {

    const swatch = e.target;
    const designType = swatch.dataset.swatchDesignType;
    const designTypes = this.querySelectorAll('[data-fieldset]');

    for (let d = 0; d < designTypes.length; d++) {
      
      const type = designTypes[d];
      
      type.classList.add("hide");
      type.querySelector("input").value = "";
      type.querySelector("input").removeAttribute("required");

    }

    this.querySelector(`[data-fieldset="${designType}"]`).classList.remove("hide");
    this.querySelector(`[data-fieldset="${designType}"] input`).setAttribute("required", "");

    this.update();

    const event = new CustomEvent('customizer:customization:update-design-type', {
      'bubbles': true,
      'detail': {
        "customization": this
      }
    });

    this.dispatchEvent(event);

  }

  updatePrice(priceInCents) {

    const price = priceInCents / 100;

    this.querySelector('.customization__price').innerHTML = price;

  }

  update() {

    const event = new CustomEvent('customizer:customization:update', {
      'bubbles': true,
      'detail': {
        "customization": this
      }
    });

    this.dispatchEvent(event);

  }

  populate(state) {

    // console.log('customization.populate()');

  }

  updateDesignType() {

    const event = new CustomEvent('customizer:customization:update-design-type', {
      'bubbles': true,
      'detail': {
        "customization": this
      }
    });

    this.dispatchEvent(event);

  }

  reset() {

    this.querySelector(`[data-swatch-embroidery-type="Flat"]`).click();
    this.querySelector(`[data-swatch-design-type="Art"]`).click();

    this.querySelector(`[data-fieldset="Art"]`).classList.remove("hide");
    this.querySelector(`[data-fieldset="Text"]`).classList.add("hide");

    const inputs = this.querySelectorAll("input");

    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i];
      input.value = "";
    }

    // this.updateDesignPrice();
    this.update();

    this.hide();

  }

  onFormSubmit(e) {

    // console.log('onFormSubmit');
    // console.log(e);

    e.preventDefault();

  }

  validateInputs() {

    const inputs = this.form.querySelectorAll('input');
    
    inputs.forEach(input => {
      // Check if input is invalid
      if (!input.validity.valid) {
        // Add class to invalid input
        input.classList.add('invalid');
      } else {
        // Remove class from valid input
        input.classList.remove('invalid');
      }
    });
    
  }

  get valid() {
    return this.form.checkValidity();
  }

  get form() {
    return this.querySelector('form');
  }

  get embroideryType() {
    return this.querySelector('[data-swatch-embroidery-type]:checked').getAttribute('data-swatch-embroidery-type');
  }

  get designType() {
    return this.querySelector('[data-swatch-design-type]:checked').getAttribute('data-swatch-design-type');
  }

  get name() {
    return this.getAttribute('data-name');
  }

  get handle() {
    return this.getAttribute('data-name');
  }

  get positionName() {
    return this.getAttribute('data-name');
  }

  get priceElement() {
    return this.querySelector('[data-price]');
  }

  get hidden() {
    return !this.classList.contains("customization--visible");
  }

  get fieldset() {
    return this.querySelector("[data-fieldset]:not(.hide)");
  }

  get selectedProductData() {
    return JSON.parse(this.querySelector('.customization-swatch__input:checked').dataset.product);
  }

  show() {
    this.classList.add("customization--visible");
    this.inputsEnable();
  }
  
  hide() {
    this.classList.remove("customization--visible");
    this.inputsDisable();
  }

  inputsDisable() {
    this.querySelectorAll('input').forEach(e => {
      e.disabled = true;
    });
  }

  inputsEnable() {
    this.querySelectorAll('input').forEach(e => {
      e.disabled = false;
    });
  }

}

class CustomizationSummary extends HTMLElement {

  connectedCallback() {

  }

  update(customization) {

    if (!customization) {
      return;
    }

    const elementPrice = this.querySelector("[data-price]");
    
    const elementEmbroideryTypeLabel = this.querySelector("[data-embroidery-type-label]");
    const elementEmbroideryType = this.querySelector("[data-embroidery-type]");
    
    const elementDesignTypeLabel = this.querySelector("[data-design-type-label]");
    const elementDesignType = this.querySelector("[data-design-type]");

    const embroideryTypeSwatches = Array.from(customization.querySelectorAll(`input[data-swatch-embroidery-type]`));
    const embroideryType = embroideryTypeSwatches.filter( e => e.checked)[0];
    
    const designTypeSwatches = Array.from(customization.querySelectorAll(`input[data-swatch-design-type]`));
    const designType = designTypeSwatches.filter( e => e.checked)[0].dataset.swatchDesignType;

    const embroideryProductData = JSON.parse(embroideryType.dataset.product)
    const price = embroideryProductData.price;
    const priceFormatted = price / 100;


    // Assignment

    let embroideryTypeText = embroideryType.dataset.swatchEmbroideryType + " Embroidery";
    let designTypeLabelText;
    let designTypeText;


    // Display

    if (designType == "Art") {
      designTypeLabelText = "Your Design";
      designTypeText = "Uploaded File";
    }
    else 
    if (designType == "Text") {
      designTypeLabelText = "Your Text";
      designTypeText = ` ${customization.querySelector('[data-input-text]').value} `;
    }

    elementEmbroideryType.innerHTML = embroideryTypeText;
    elementDesignType.innerHTML = designTypeText;
    elementDesignTypeLabel.innerHTML = designTypeLabelText;

    elementPrice.innerHTML = priceFormatted;

    // const cProduct = JSON.parse(embroideryType.dataset.product)

    // const price = cProduct.price / 100;

    // elementPrice.innerHTML = price;

  }

  reset() {
    
  }

  show() {
    this.classList.remove("hide");
  }

  hide() {
    this.classList.add("hide");
  }

}

class CustomizerPlacementsContainer extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {

  }

  get customizer() {
    return this.closest(".customizer");
  }

  get activePlacements() {

    const array = Array.from(this.querySelectorAll('customizer-placement'));
    const arrayFiltered = array.filter(e => e.classList.contains("customizer-placement--selected"));

    return arrayFiltered;
    
  }

  reset() {

    const placements = this.activePlacements;

    placements.forEach(placement => {
      placement.reset();
    });
    
  }

}

class CustomizerPlacement extends HTMLElement {

  constructor() {

    super();

    this.addEventListener('click', this.onClick.bind(this));

  }

  connectedCallback() {

  }

  onClick(event) {

    this.toggle();

  }

  toggle() {


    if (this.dataset.group) {
      if (this.disabled) {
        this.closest("customizer-placements").querySelectorAll("customizer-placement").forEach(e => {
          e.deselect();
          e.enable();
          // e.classList.remove("customizer-placement--disabled");
          // e.classList.remove("customizer-placement--selected");
        });
      }
    }

    if (!this.selected) {

      this.customization.show();
      this.select();

      if (this.group) {
        this.groupedPlacements.forEach(e => {
          if (!e.selected) {
            e.disable();
          }
        });
      }

    }
    else {

      this.customization.hide();
      this.deselect();

      if (this.group) {
        this.groupedPlacements.forEach(e => {
          if (e.disabled) {
            e.enable();
          }
        });
      }

      this.customization.reset();

    }

    this.checkForMessages();

  }

  checkForMessages() {

    const messages = this.closest('customizer-section').querySelector('customization-messages');
    let selectedPlacements = 0;

    for (let i = 0; i < this.allPlacements.length; i++) {
      const placement = this.allPlacements[i];
      if (placement.classList.contains('customizer-placement--selected')) {
        selectedPlacements++;
      }
    }

    if (selectedPlacements > 0) {
      messages.classList.add("hide");
    }
    else {
      messages.classList.remove("hide");
    }

  }

  get allPlacements() {
    return this.closest('.customizer-placements-container').querySelectorAll('customizer-placement');
  }

  get groupedPlacements() {
    return this.closest("customizer-placements").querySelectorAll(`customizer-placement[data-group="${this.group}"]`);
  }

  get group() {
    return this.dataset.group;
  }

  get customization() {
    return document.querySelector(`#${this.getAttribute("aria-controls")}`);
  }

  disable() {
    this.classList.add("customizer-placement--disabled");
  }
  
  enable() {
    this.classList.remove("customizer-placement--disabled");
  }

  select() {

    this.classList.add("customizer-placement--selected");

    var event = new CustomEvent('customizer:placement:select', { 
      'bubbles' : true,
      'detail': { 
        "placement": this
      } 
    });

    this.dispatchEvent(event);

  }
  
  deselect() {
    
    this.classList.remove("customizer-placement--selected");

    var event = new CustomEvent('customizer:placement:deselect', {
      'bubbles': true,
      'detail': {
        "placement": this
      }
    });

    this.dispatchEvent(event);

  }

  get selected() {
    return this.classList.contains('customizer-placement--selected');
  }

  set selected(s) {

    if (s == true) {
      this.classList.add('customizer-placement--selected');

      if (this.group) {
        this.groupedPlacements.forEach(e => {
          if (!e.selected) {
            e.disable();
          }
        });
      }
      
      return true;
      
    }
    else {

      this.classList.remove('customizer-placement--selected');

      if (this.group) {
        this.groupedPlacements.forEach(e => {
          if (e.disabled) {
            e.enable();
          }
        });
      }

      return false;
      
    }

  }

  get disabled() {
    return this.classList.contains('customizer-placement--disabled');
  }

  reset() {
    if (this.selected) {
      this.toggle();
    }
  }

}

class CustomizerOrder extends HTMLElement {

  connectedCallback() {

    this.elementImage = this.querySelector("[data-image] img");
    this.elementOption1 = this.querySelector("[data-option-1]");
    this.elementOption2 = this.querySelector("[data-option-2]");
    this.elementOption3 = this.querySelector("[data-option-3]");
    this.elementBasePrice = this.querySelector("[data-base-price]");
    this.elementCustomizationPrice = this.querySelectorAll("[data-customizations-price]");
    this.elementTotalPrice = this.querySelector("[data-total-price]");

    this.reset();

    this.update();

  }

  update() {

    this.updateImage(this.customizer.selectedVariantData);
    this.updateOptions(this.customizer.selectedVariantData);
    this.updatePrices(this.customizer.selectedVariantData);

    this.updateCustomizations();

  }

  updateImage(variant) {
    if (!variant) {
      return;
    }
    this.elementImage.src = variant?.featured_image.src;
  }

  updateOptions(variant) {

    if (!variant) {
      return;
    }

    if (variant.option1) {
      this.elementOption1.innerHTML = variant.option1;
    }

    if (variant.option2) {
      this.elementOption2.innerHTML = variant.option2;
    }

    if (variant.option3) {
      this.elementOption3.innerHTML = variant.option3;
    }

  }

  updatePrices(variant) {

    if (!variant) {
      return;
    }

    if (variant.price) {
      this.elementBasePrice.innerHTML = variant.price / 100;
    }

    const customizations = this.customizer.activeCustomizations;

    let totalPrice = variant.price;

    customizations.forEach(customization => {
      totalPrice += customization.selectedEmbroideryProduct.price;
    });

    this.elementTotalPrice.innerHTML = totalPrice / 100;

  }

  updateCustomizations() {

    const customizations = this.customizer.activeCustomizations;
    const customizer = this.customizer;

    if (!customizations) {
      return;
    }

    let customizationsTotalPrice = 0;

    // Update Prices
    customizations.forEach(customization => {
      customizationsTotalPrice += customization.selectedEmbroideryProduct.price;
    });

    Array.from(this.elementCustomizationPrice).forEach(element => {
      element.innerHTML = customizationsTotalPrice / 100;
    });

    // Update Summaries 
    customizations.forEach(customization => {
      
      const handle = customization.dataset.handle;
      const customizationSummary = customizer.querySelector(`customization-summary[data-handle="${handle}"]`);
      
      customizationSummary.update(customization);

    });

  }

  reset() {

    // this.elementImage.innerHTML = "";

    // this.elementOptionColor.innerHTML = "";
    // this.elementOptionSize.innerHTML = "";
    // this.elementBasePrice.innerHTML = "";
    // this.elementCustomizationPrice.innerHTML = "";
    // this.elementTotal.innerHTML = "";

  }

  show() {
    this.classList.remove("hide");
  }

  hide() {
    this.classList.add("hide");
  }

  get customizer() {
    return this.closest("main-customizer");
  }

}

customElements.define('customization-details', Customization);
customElements.define('customization-summary', CustomizationSummary);
customElements.define('customizer-quantity-input', CustomizerQuantityInput);
customElements.define('customizer-order', CustomizerOrder);
customElements.define('customizer-placement', CustomizerPlacement);
customElements.define('customizer-placements-container', CustomizerPlacementsContainer);
customElements.define('main-customizer', Customizer);

document.querySelectorAll(".customizer").forEach(e => {
  // e.updateOrder();
})